module.exports = __webpack_public_path__ + "img/fa-brands-400.778b1f2.svg";